/**
 * @auth 赖传峰
 * @date 2021/12/14 14:42
 */

export const enum AvatarSize {
  NORMAL = 'normal',
  SMALL = 'small',
  LARGE = 'large',
}

export const enum Shape {
  CIRCLE = 'circle',
  SQUARE = 'square',
}
